  export const TITLE_TYPE_LIST = [
    // {
    //   label: '流动资产',
    //   value: '010101',
    // },
    // {
    //   label: '长期投资',
    //   value: "010102",
    // },
    // {
    //   label: '固定资产净额',
    //   value: '010103',
    // },
    // {
    //   label: '其他固定资产',
    //   value: '010104',
    // },
    // {
    //   label: '无形资产及其他资产',
    //   value: '010105',
    // },
    // {
    //   label: '资产总计',
    //   value: '111',
    // },
    // {
    //   label: '流动负债',
    //   value: '010201'
    // },
    // {
    //   label: '非流动负债',
    //   value: '010202',
    // },
    // {
    //   label: '负债合计',
    //   value: '010203',
    // },
    // {
    //   label: '所有者权益',
    //   value: '010204',
    // },
    // {
    //   label: '损益指标',
    //   value: '020101',
    // },
    // {
    //   label: '经营活动现金流入',
    //   value: '030101',
    // },
    // {
    //   label: '经营活动现金流出',
    //   value: '030102',
    // },
    // {
    //   label: '投资活动现金流入',
    //   value: '030201',
    // },
    // {
    //   label: '投资活动现金流出',
    //   value: '030202',
    // },
    // {
    //   label: '筹资活动现金流入',
    //   value: '030301',
    // },
    // {
    //   label: '筹资活动现金流出',
    //   value: '030302',
    // },
    // {
    //   label: '汇率变动对现金的影响',
    //   value: '030401',
    // },
    // {
    //   label: '现金及现金等价物净增加额',
    //   value: '030501',
    // },
    // {
    //   label: '将净利润调节为经营活动现金流量',
    //   value: '040101',
    // },
    // {
    //   label: '不涉及现金收支的投资和筹资活动',
    //   value: '040201',
    // },
    // {
    //   label: '资产现金及现金等价物净增加情况总计',
    //   value: '040301',
    // },
    // {
    //   label: '批量导入指标',
    //   value: '120',
    // },
    // {
    //   label: '负债及所有者权益总计',
    //   value: '222',
    // },
    // {
    //   label: '经营活动产生的现金流量净额',
    //   value: '444',
    // },
    // {
    //   label: '投资活动产生的现金流量净额',
    //   value: '555',
    // },
    // {
    //   label: '筹资活动产生的现金流量净额',
    //   value: '666',
    // },
    {
      label: '成长能力指标',
      value: '444',
    },
    {
      label: '主要财务指标',
      value: '111',
    },
    {
      label: '盈利能力指标',
      value: '222',
    },
    {
      label: '偿债能力指标',
      value: '333',
    },
    {
      label: '运营能力指标',
      value: '555',
    },
  ]

  export const TITLE_TYPE_LISTS = [
    {
      label: '非财务指标',
      value: '050101',
    },
  ]
  
  export const TARGET_TYPE_LIST = [
    {
      label: '财务指标',
      value: 5,
    },
    {
      label: '非财务指标',
      value: 0,
    },
  ]

  export const DATA_TYPE_LIST = [
    {
      label: '数字',
      value: 1,
    },
    {
      label: '下拉选',
      value: 2,
    },
    {
      label: '文本',
      value: 3,
    },
  ]